<nz-card nzTitle="Products" [nzExtra]="extraTemplate" class="shadow-sm">

	<nz-table #basicTable [nzData]="products" [nzLoading]="loading" [nzPageSize]="10" [nzBordered]="true" nzSize="middle">

		<thead>
			<tr>
				<th>ID</th>
				<th>Created</th>
				<th>Name</th>
				<th>Description</th>
				<th>Package(s)</th>
				<th>Brochure</th>
				<th>Datasheet</th>
				<th>Logo</th>
				<th>Link</th>
                <th>Status</th>
				<th nzAlign="center">Action</th>
			</tr>
		</thead>

		<tbody>
			@for (product of basicTable.data; track product.id) {
			<tr>
				<td>{{ product.id }}</td>
				<td>{{ product.createdAt | date: 'yyyy-MM-dd' }}</td>
				<td>{{ product.name }}</td>
				<td style="max-width: 250px; vertical-align: top;">
    
					@if (!expandedDescriptions.has(product.id ?? 0)) {
						<div nz-typography 
							nzEllipsis 
							[nzEllipsisRows]="2"
							class="text-muted" 
							style="margin-bottom: 0;">
							{{ product.description }}
						</div>
						
						@if (product.description && product.description.length > 80) {
							<a nz-button nzType="link" nzSize="small" (click)="toggleDescription(product.id ?? 0)" style="padding: 0; font-size: 12px;">
								Expand
							</a>
						}
					} 
					
					@else {
						<div style="word-break: break-word; white-space: pre-wrap; margin-bottom: 0;">
							{{ product.description }}
						</div>
						<a nz-button nzType="link" nzSize="small" (click)="toggleDescription(product.id ?? 0)" style="padding: 0; font-size: 12px;">
							Collapse
						</a>
					}

				</td>
				<td nzAlign="center">{{product.packageCount}}</td>
				<td nzAlign="center">
					@if (product.hasBrochure) {
						<a nz-button nzType="link" (click)="viewMedia(product, mediaTypeEnum.ProductBrochurePdf)">
							<span nz-icon nzType="file-pdf" nzTheme="twotone" nzTwotoneColor="#eb2f96"></span> View
						</a>
					} @else {
						<span nz-typography nzType="secondary">-</span>
					}
				</td>

				<td nzAlign="center">
					@if (product.hasDatasheet) {
						<a nz-button nzType="link" (click)="viewMedia(product, mediaTypeEnum.ProductDatasheetPdf)">
							<span nz-icon nzType="file-pdf" nzTheme="twotone" nzTwotoneColor="#eb2f96"></span> View
						</a>
					} @else {
						<span nz-typography nzType="secondary">-</span>
					}
				</td>

				<td nzAlign="center">
					@if (product.hasLogo) {
						<a nz-button nzType="link" (click)="viewMedia(product, mediaTypeEnum.ProductImage)">
							<span nz-icon nzType="picture" nzTheme="twotone"></span> View
						</a>
					} @else {
						<span nz-typography nzType="secondary">-</span>
					}
				</td>
				<td>{{ product.link }}</td>

				<td nzAlign="center">
					@switch (product.status) {
                        @case (ProductStatusEnum.Active) {
                        <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" nz-tooltip
                            nzTooltipTitle="Active"></span>
                        }
                        @case (ProductStatusEnum.Disabled) {
                        <span nz-icon nzType="minus-circle" nzTheme="twotone" nzTwotoneColor="#ff4d4f" nz-tooltip
                            nzTooltipTitle="Disabled"></span>
                        }
                        @default {
                        <span nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip nzTooltipTitle="Unknown"></span>
                        }
					}
				</td>

				<td nzAlign="center">
					<button nz-button nzType="primary" nzGhost nzSize="small" (click)="managePackages(product)"
						class="btn-icon-flex btn-spacer">
						<span nz-icon nzType="appstore" style="margin-right: 4px;"></span> Packages
					</button>

					<button nz-button nzType="default" nzSize="small" (click)="editProduct(product)"
						class="btn-icon-flex btn-spacer">
						<span nz-icon [nzType]="authService.hasAccess(PermissionEnum.ProductsEdit) ? 'edit' : 'eye'" style="margin-right: 4px;"></span>
						{{ authService.hasAccess(PermissionEnum.ProductsEdit) ? 'Edit' : 'View Products' }}
					</button>

					@if (authService.hasAccess(PermissionEnum.ProductsEdit)) {
						<button nz-button nzType="default" nzSize="small" nz-dropdown [nzDropdownMenu]="menu"
							class="btn-icon-flex">
							More <span nz-icon nzType="down" style="margin-left: 4px;"></span>
						</button>

						<nz-dropdown-menu #menu="nzDropdownMenu">
							<ul nz-menu>

								@if (product.status === ProductStatusEnum.Active || product.status === ProductStatusEnum.Disabled) {

									<li nz-menu-divider></li>

									@if (product.status === ProductStatusEnum.Active) {
									<li nz-menu-item nzDanger (click)="disable(product)">
										<span nz-icon nzType="stop"></span> Disable
									</li>
									}
									@else if (product.status === ProductStatusEnum.Disabled) {
									<li nz-menu-item (click)="enable(product)">
										<span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
										Enable
									</li>
									}
								}
							</ul>
						</nz-dropdown-menu>
					}
				</td>
			</tr>
			}
		</tbody>
	</nz-table>

</nz-card>

<ng-template #extraTemplate>
	@if (authService.hasAccess(PermissionEnum.ProductsAdd)) {
		<button nz-button nzType="primary" (click)="addProduct()">
			<span nz-icon nzType="plus"></span> Add Product
		</button>
	}
</ng-template>

<app-product-editor-modal modalId="productEditorModal" (saved)="onSave()"></app-product-editor-modal>
<app-product-packages-modal modalId="productPackagesModal"></app-product-packages-modal>